import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  ${({ theme }) => `
    font-family: ${theme.fonts.citiSans};
    color: ${theme.colors.white};
    font-size: ${theme.getValue(28)};
  `}
  & p {
    margin: 0;
    font-variant-numeric: tabular-nums;
  }
  & svg {
    ${({ theme }) => `
      height: ${theme.getValue(38)};
      width: ${theme.getValue(38)};
      margin-right: ${theme.getValue(8)};
    `}
  }
`;
